import ENDPOINTS from 'api/endpoints';
import { doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { RespondBody, RespondResponse } from './types';

const mapClientEnv = (clientEnv: string) =>
  clientEnv === 'draft' ? 'sandbox' : clientEnv;

export type AgentVersion = {
  artifact_version: string;
  lambda_deployment_version?: string;
};

/**
 * Unified startChat — single endpoint for all environments.
 * Maps 'draft' → 'sandbox' for client_env and includes agent_version when present.
 */
export const startChatUnified = ({
  accountId,
  projectId,
  clientEnv,
  languageCode,
  variantId,
  channel,
  agentVersion,
}: {
  accountId: string;
  projectId: string;
  clientEnv: string;
  languageCode: string;
  variantId?: string;
  channel?: string;
  agentVersion?: AgentVersion;
}) => {
  return doPost<RespondResponse>(
    generateNextPath(ENDPOINTS.START_CHAT, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      client_env: mapClientEnv(clientEnv),
      asr_lang_code: languageCode,
      tts_lang_code: languageCode,
      variant_id: variantId,
      channel,
      ...(agentVersion && { agent_version: agentVersion }),
    },
    { version: 'v2' },
  );
};

/**
 * Unified respond — single endpoint for all environments.
 * Maps 'draft' → 'sandbox' for client_env.
 */
export const respondUnified = ({
  accountId,
  projectId,
  conversationId,
  clientEnv,
  body,
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
  clientEnv: string;
  body: RespondBody;
}) => {
  return doPost<RespondResponse>(
    generateNextPath(ENDPOINTS.RESPOND, {
      accountId,
      projectId,
      conversationId,
    }),
    LOGGER_TYPE.JUPITER,
    { ...body, client_env: mapClientEnv(clientEnv) },
    { version: 'v2' },
  );
};
